// Onboarding's on-chain step, ported off @cere-ddc-sdk/blockchain onto
// @cef-ai/account's provisioning.ensure (see lib/platform-client/onboarding.ts).
// The old auto-add-proxy.ts submitted proxy.addProxy via CereWalletSigner; this
// routes the same extrinsic through the chain-free @cef-ai/signer `Signer` and
// @cef-ai/chain. We keep the `{ txHash }` return so the SDK-agnostic onboarding
// state machine's `addProxy` dep is unchanged.

import type { Signer } from '@cef-ai/signer';
import { ensureProvisioned, type EnsureProvisionedOpts } from '@/lib/platform-client';
import { gatewayHexToSs58 } from '@/lib/platform-client/gate-helpers';

export interface ProvisionAddProxyOpts {
  signer: Signer;
  rpcEndpoint: string;
  gatewayPubKeyHex: string;
  proxyType?: EnsureProvisionedOpts['proxyType'];
  /** Test seam mirroring lib/platform-client/onboarding.ts. */
  _provisioning?: EnsureProvisionedOpts['_provisioning'];
}

export async function provisionAddProxy(opts: ProvisionAddProxyOpts): Promise<{ txHash: string }> {
  const { txHash } = await ensureProvisioned(opts.signer, {
    chainUrl: opts.rpcEndpoint,
    gateway: gatewayHexToSs58(opts.gatewayPubKeyHex),
    proxyType: opts.proxyType ?? 'NonTransfer',
    ...(opts._provisioning ? { _provisioning: opts._provisioning } : {}),
  });
  return { txHash };
}
